import { connect } from 'react-redux';
import Sidebar from '../../components/metadata/sidebar';

const mapStateToProps = function(state) {
	return {
		visible: state.features.metadata
	};
}

const mapDispatchToProps = {}

const SidebarContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	undefined,
	{
		pure: true
	}
)(Sidebar)

export default SidebarContainer;